import type { ReactNode } from "react";
import { Skeleton } from "@/components/ui/skeleton.tsx";

const PLACEHOLDER_ROW_WIDTHS = ["w-3/4", "w-1/2", "w-2/3"];

export interface LoadMoreFooterProps {
    children?: ReactNode;
}

export function LoadMoreFooter({ children }: LoadMoreFooterProps) {
    return (
        <Skeleton isLoading inert aria-hidden="true" className="py-2">
            {children ?? (
                <div className="space-y-3">
                    {PLACEHOLDER_ROW_WIDTHS.map(width => (
                        <div key={width}>
                            <span className={`block ${width}`}>Xxxxxxxx xxxxxxxxx xxxx</span>
                        </div>
                    ))}
                </div>
            )}
        </Skeleton>
    );
}
